import api from '../api';

// MIGRATION: Independent agents now use the unified /payment-links endpoints.
// Most fields match directly (client_email, client_name, client_phone, amount,
// payment_type, description, custom_message, expires_in_hours, session_token,
// created_at, expires_at). Two differences are adapted here so the existing
// Independent UI needs no changes:
//  - status enum uses 'completed' instead of the legacy 'paid'
//  - cancel is a DELETE (soft-cancels + strips sensitive payment data) instead
//    of a PUT .../cancel, and reminders use /send-reminder instead of /reminder
const fromUnifiedLink = (link) => {
  if (!link || typeof link !== 'object') return link;
  return {
    ...link,
    status: link.status === 'completed' ? 'paid' : link.status
  };
};

export const independentPaymentLinksService = {
  getAll: async () => {
    const response = await api.get('/payment-links');
    return Array.isArray(response.data) ? response.data.map(fromUnifiedLink) : response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/payment-links/${id}`);
    return fromUnifiedLink(response.data);
  },

  create: async (linkData) => {
    const response = await api.post('/payment-links', linkData);
    return response.data;
  },

  update: async (id, linkData) => {
    const response = await api.put(`/payment-links/${id}`, linkData);
    return response.data;
  },

  cancel: async (id) => {
    const response = await api.delete(`/payment-links/${id}`);
    return response.data;
  },

  resend: async (id) => {
    const response = await api.post(`/payment-links/${id}/resend`);
    return response.data;
  },

  sendReminder: async (id) => {
    const response = await api.post(`/payment-links/${id}/send-reminder`);
    return response.data;
  }
};

export default independentPaymentLinksService;
